import { styled, Typography } from "@mui/material";
import { ArrowIcon } from "@volt_developers/components";
import { Link } from "react-router-dom";

import { Can } from "components/can";
import { ACTION_LIST } from "models/role/action";
import { SUBJECT_CIRCUIT_BREAKER } from "models/role/subject";

import { useRuleScoreItem } from "../../hooks/useRuleScoreItem";
import { riskRuleTranslator } from "../../utils/riskRuleTranslator";

import type { RiskRule } from "../../models/RiskRule";

export interface RulesScoreItemProps {
  isSameCustomer: boolean;
  rule: RiskRule;
}

const BASE_URL = "/circuit-breaker/risk-rules";

export function RulesScoreItem({ isSameCustomer, rule }: RulesScoreItemProps) {
  const { data } = useRuleScoreItem();

  const params = new URLSearchParams();

  params.append("search", rule.id);

  if (!data?.bank) {
    return null;
  }

  const content = riskRuleTranslator(rule, data.bank.name);

  return (
    <Container>
      <Typography variant="small">
        <Can do={ACTION_LIST} on={SUBJECT_CIRCUIT_BREAKER}>
          {isSameCustomer ? (
            <StyledLink to={`${BASE_URL}?${params}`}>
              {content}
              <StyledArrowIcon fontSize="medium" />
            </StyledLink>
          ) : (
            content
          )}
        </Can>
        <Can do={ACTION_LIST} on={SUBJECT_CIRCUIT_BREAKER} not>
          {content}
        </Can>
      </Typography>
      <Typography variant="button">{rule.score}</Typography>
    </Container>
  );
}

const Container = styled("div")(({ theme }) => ({
  justifyContent: "space-between",
  display: "flex",
  marginTop: theme.spacing(2),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.dui50,
  textDecoration: "none",

  "&:hover": {
    textDecoration: "underline",
  },
}));

const StyledArrowIcon = styled(ArrowIcon)(({ theme }) => ({
  marginLeft: 5,
  fontSize: 24,
  color: theme.palette.primary.main,
  verticalAlign: "bottom",
}));
